import React from 'react';
import './ImageStyleSheet.css';

function uml1() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/umass1.jpeg" className='img-view'/>
        </div>
    )
}

export default uml1

